import { ComponentType } from '../validators';

const NonElectricalComponentTypes: ComponentType[] = ['controller', 'software', 'other'];

export const isNonElectricalComponentType = (type?: ComponentType): boolean =>
    Boolean(type && NonElectricalComponentTypes.includes(type));
